/* tslint:disable:max-line-length */
import { SegmentSpecificMessages } from "../../types/types";

export const teacherMessages: SegmentSpecificMessages = {
  emailExplanation: "Must be your school-issued email address",
  schoolName: "School name",
  schoolNamePlaceholder: "School name",
  step: {
    personalInfo: {
      title: "Unlock this Teaching Staff-Only Offer",
      subtitle:
        "Verify you're a teacher, faculty, or staff at an accredited educational institution.",
      howDoesVerifyingWorkDetails:
        "To be eligible for this offer, you must currently be employed as a teacher, faculty, or staff at an accredited educational institution." +
        "<br></br>" +
        "{companyName} uses SheerID, a trusted partner, to verify that you are a current teacher, faculty, or staff member. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: "Check Your Name & Email",
        subtitle: "Your full name and email address must match what is on record with your school.",
      },
      verifyingTitle: "Verifying your teacher status",
      submitButtonText: "Verify My Teacher Status",
    },
    docUpload: {
      uploadInstructions: "Upload your school-issued document that shows",
      title: "To continue, upload documents that confirm your teacher status",
      whoIsSheerId:
        "Document review is handled by SheerID, a trusted partner who specializes in verifying teachers.",
    },
    success: {
      title: "You've been verified",
      subtitle: "You are now eligible for this special offer.",
      redirectButtonText: "Continue",
    },
  },
};
